import SuperAdminActivity from './SuperAdminActivity';
export default SuperAdminActivity;
